import request from '@/utils/request'
const apiPath = '/sys/sysGoodsCategorize'
const sysGoodsCategorizeApi = {
  /**
   * 新增【商品分类】
   */
  create(data) {
    return request.post(apiPath, data)
  },
  /**
   * 修改【商品分类】
   */
  update(data) {
    return request.put(apiPath, data)
  },
  /**
   * 分页查询【商品分类】
   */
  fetchList(query) {
    return request.get(apiPath, { params: query })
  },
  fetchTreeList(query) {
    return request.get(apiPath + '/tee/treeList', { params: query })
  },
  /**
   * 查询【商品分类】选项列表
   */
  findOptions(query) {
    return request.get(`${apiPath}/options`, { params: query })
  },
  /**
   * 查看【商品分类】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 删除单个【商品分类】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
  setIsEnable(data) {
    return request.put(apiPath + '/tee/setIsEnable', data)
  },
  setIsEnableBatch(data) {
    return request.put(apiPath + '/tee/setIsEnableBatch', data)
  },
}
export default sysGoodsCategorizeApi
